import React, { createContext, useContext } from "react"
import { EventData, GuestData } from "../utils/badgeDataResolver"

type BadgeDataState = {
  guestData?: GuestData
  eventData?: EventData
}

const BadgeDataContext = createContext<BadgeDataState | null>(null)

export const useBadgeData = () => {
  const context = useContext(BadgeDataContext)

  return context || { guestData: undefined, eventData: undefined }
}

type BadgeDataProviderProps = {
  guestData?: GuestData
  eventData?: EventData
  children: React.ReactNode
}

export const BadgeDataProvider = ({
  guestData,
  eventData,
  children,
}: BadgeDataProviderProps) => (
  <BadgeDataContext.Provider value={{ guestData, eventData }}>
    {children}
  </BadgeDataContext.Provider>
)
